<template>
  <div class="agreement">
    <span class="agreement-text">
      Bằng việc bấm Tiếp tục quý khách đã đồng ý để FPT Telecom liên hệ tư vấn sản phẩm dịch vụ phù hợp với nhu cầu. 
      Chi tiết xem tại 
      <a
        target="_blank"
        class="agreement-link"
        :href="isLink"
      >
        Chính sách xử lý dữ liệu cá nhân
      </a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'AgreementText',
  data() {
    return {
      hostName: window.location.hostname
    }
  },
  computed: {
    isProduct() {
      return (
        this.hostName === 'fpt.vn' ||
        this.hostName === 'shop-beta.fpt.vn'
      );
    },
    isLink() {
      return this.isProduct
        ? 'https://fpt.vn/ho-tro/huong-dan-thu-tuc/xi-chinh-sach-xu-ly-du-lieu-ca-nhan/286.html'
        : 'https://staging.fpt.vn/ho-tro/huong-dan-thu-tuc/xi-chinh-sach-xu-ly-du-lieu-ca-nhan/51.html';
    }
  }
}
</script>
